import React from 'react';
import { useMediaQuery } from 'react-responsive';
import { Helmet } from 'react-helmet-async';
import { PredictionsProvider } from './context/PredictionsContext';
import Desktop from './Desktop';
import Mobile from './Mobile';
import HeroBanner from './components/HeroBanner';

const Prediction = () => {
  const isDesktop = useMediaQuery({ query: '(min-width: 1024px)' });
  
  return (
    <PredictionsProvider>
      <Helmet>
        <script src="https://s3.tradingview.com/tv.js" type="text/javascript" id="tradingViewWidget" />
      </Helmet>
      <div className="w-full min-h-screen bg-gradient-to-b from-[#000000] to-[#0a0a2e] text-white py-6 px-4 md:px-8">
        <div className="max-w-7xl mx-auto">
          <HeroBanner />
          <div className="w-full bg-[#000] rounded-xl overflow-hidden border border-[#7900ff]/30">
            {isDesktop ? <Desktop /> : <Mobile />}
          </div>
        </div>
      </div>
    </PredictionsProvider>
  );
};

export default Prediction;
